import FluidHeader from './FluidHeader'
import MobileMenu from './MobileMenu'
import LazyLoad from 'vanilla-lazyload'
import { SelectCourse } from './SelectCourse'
import { NumberUp } from './NumberUp'
import { ListReasons } from './ListReasons'

$(document).ready(() => {
  const myLazyLoad = new LazyLoad()
  AOS.init()
  MobileMenu()
  FluidHeader()
  SelectCourse()
  NumberUp()
  ListReasons()
})
